/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PraticaCittadinoEsitoGraduatoriaDTO { 
    esito?: PraticaCittadinoEsitoGraduatoriaDTOEsitoEnum;
    importo_riconosciuto?: number;
    numero_componenti?: number;
}
export enum PraticaCittadinoEsitoGraduatoriaDTOEsitoEnum {
    RICHIESTA_AMMESSA_FINANZIATA = 'RICHIESTA_AMMESSA_FINANZIATA',
    RICHIESTA_AMMESSA_NON_FINANZIATA = 'RICHIESTA_AMMESSA_NON_FINANZIATA'
};



